import { useResetVerificationTimesheetMutation } from '#/features/timesheet-verification/hooks/useResetVerificationTimesheetMutation';
import { Button } from '#/shared/components/Button';
import { ModalContent } from '#/shared/components/Modal';
import { Modal } from '#/shared/components/Modal';
import { useAnalytics } from '#/shared/hooks/useAnalytics';
import { useMonitoring } from '#/shared/hooks/useMonitoring';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

export interface ResetVerifiedTimesheetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ResetVerifiedTimesheetModal({ isOpen, onClose }: Readonly<ResetVerifiedTimesheetModalProps>) {
  const resetVerificationRequest = useResetVerificationTimesheetMutation();
  const { noticeError } = useMonitoring();
  const { track } = useAnalytics();
  const timesheetId = useTimesheetStore(state => state.timesheet?.timesheetId ?? '');

  const handleConfirm = async () => {
    try {
      track('Online approval web - Delete verification', {
        Timesheet_ID: timesheetId,
      });

      await resetVerificationRequest.mutateAsync();

      onClose();
    } catch (error) {
      noticeError(new Error('Failed to reset verification'), { originalError: error });
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalContent title={'Reset verification?'} onCancel={handleCancel}>
        <div className="px-24 pb-4 flex flex-col gap-16 overflow-y-auto">
          <p>Once the timesheet is reset, verification information is deleted and cannot be recovered.</p>
        </div>
        <div className="px-24 flex gap-12">
          <Button variant="outline" size="medium" onPress={handleCancel} className="w-full">
            Cancel
          </Button>
          <Button size="medium" variant="error" className="w-full" onPress={handleConfirm}>
            Delete
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
